<template>
  <Dialog
    :visible="notificationStore.sessionExpiryModal.visible"
    modal
    :closable="false"
    :dismissableMask="false"
    :closeOnEscape="false"
    :draggable="false"
    :style="{ width: '28rem' }"
  >
    <template #header>
      <div class="session-modal-header">
        <i class="pi pi-exclamation-triangle" />
        <span>{{ notificationStore.sessionExpiryModal.summary }}</span>
      </div>
    </template>

    <div class="session-modal-content">
      <p>{{ notificationStore.sessionExpiryModal.detail }}</p>
      <small>Redirecting to login...</small>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
  import useNotifications from '@/store/notification'

  const notificationStore = useNotifications()
</script>

<style scoped>
  .session-modal-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 700;
  }

  .session-modal-header i {
    color: #d97706;
  }

  .session-modal-content {
    display: grid;
    gap: 0.5rem;
  }

  .session-modal-content p {
    margin: 0;
    font-size: 0.975rem;
    line-height: 1.4;
  }

  .session-modal-content small {
    color: #6b7280;
  }
</style>
